module.exports = __webpack_public_path__ + "img/adaf.f72d7b7.png";